// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"535":"54622e98","780":"867121c7"}[chunkId] + ".chunk.css";
};